import {
  fetchOrders,
  create,
  fetchHistory,
  setTrackNumber
} from '../../../api/return'
import _ from 'lodash'

// initial state
const state = {
  currentTab: 'return',
  orders: [],
  limit: 20,
  offset: 0,
  filter: {
    queryString: '',
    dateStart: 0,
    dateEnd: 0
  },
  hasMore: true,
  currentItem: null,
  PREVIEW_TEXT: '',
  DETAIL_TEXT: '',
  G_PHOTO: [],
  B_PHOTO: [],
  SET_OF_VARIANT: 71,
  SET_OF_VARIANT_VARIANTS: [
    {
      value: 71,
      title: 'Возврат денег'
    },
    {
      value: 72,
      title: 'Обмен товара'
    }
  ],
  history: [],
  loading: false,
  error: ''
}

// getters
const getters = {
  currentTab: state => state.currentTab,
  orders: state => state.orders,
  currentItem: state => state.currentItem,
  PREVIEW_TEXT: state => state.PREVIEW_TEXT,
  DETAIL_TEXT: state => state.DETAIL_TEXT,
  G_PHOTO: state => state.G_PHOTO,
  B_PHOTO: state => state.B_PHOTO,
  SET_OF_VARIANT: state => state.SET_OF_VARIANT,
  SET_OF_VARIANT_VARIANTS: state => state.SET_OF_VARIANT_VARIANTS,
  history: state => state.history,
  loading: state => state.loading,
  error: state => state.error,
  filterQueryString: state => state.filter.queryString,
  filterDateStart: state => state.filter.dateStart,
  filterDateEnd: state => state.filter.dateEnd
}

// actions
const actions = {
  fetchOrders: _.throttle(async ({commit, state}) => {
    if (state.hasMore) {
      let limit = state.limit
      let offset = state.offset
      let q = state.filter.queryString
      let dateStart = state.filter.dateStart
      let dateEnd = state.filter.dateEnd

      commit('setOffset', {offset: offset + limit})
      let data = await fetchOrders({offset, limit, q, dateStart, dateEnd})
      commit('setOrders', {orders: state.orders.concat(data.orders)})
      commit('setHasMore', {hasMore: data.hasMore})
    }
  }, 500),
  async create ({commit, state, dispatch}) {
    commit('loading', true)
    await create({
      PREVIEW_TEXT: state.PREVIEW_TEXT,
      DETAIL_TEXT: state.DETAIL_TEXT,
      G_PHOTO: state.G_PHOTO,
      B_PHOTO: state.B_PHOTO,
      SET_OF_VARIANT: state.SET_OF_VARIANT,
      item: state.currentItem
    })
    dispatch('fetchHistory')
    commit('setCurrentItem', {item: null})
    commit('setTab', {tab: 'history'})
    commit('loading', false)
  },
  async fetchHistory ({commit, state}) {
    let history = await fetchHistory()
    commit('loading', true)
    commit('setHistory', {history})
    commit('loading', false)
  },
  setTrackNumber: _.debounce(({commit}, {id, trackNumber}) => {
    setTrackNumber(id, trackNumber)
  }, 500)
}

// mutations
const mutations = {
  setTab (state, {tab}) {
    state.currentTab = tab
  },
  setOrders (state, {orders}) {
    state.orders = orders
  },
  setOffset (state, {offset}) {
    state.offset = offset
  },
  setHasMore (state, {hasMore}) {
    state.hasMore = hasMore
  },
  setCurrentItem (state, {item}) {
    state.currentItem = item
  },
  setPreviewText (state, {previewText}) {
    state.PREVIEW_TEXT = previewText
  },
  setDetailText (state, {detailText}) {
    state.DETAIL_TEXT = detailText
  },
  setGPhoto (state, {gPhoto}) {
    state.G_PHOTO = gPhoto
  },
  setBPhoto (state, {bPhoto}) {
    state.B_PHOTO = bPhoto
  },
  setSetOfVariant (state, {setOfVariant}) {
    state.SET_OF_VARIANT = setOfVariant
  },
  setHistory (state, {history}) {
    state.history = history
  },
  loading (state, payload) {
    state.loading = payload
  },
  setFilterQueryString (state, payload) {
    state.filter.queryString = payload
  },
  setFilterDateStart (state, payload) {
    state.filter.dateStart = payload
  },
  setFilterDateEnd (state, payload) {
    state.filter.dateEnd = payload
  },
  clearOrders (state) {
    state.orders.splice(0, state.orders.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/return.js